import React from 'react';
import PropTypes from 'prop-types';
import { AVAILABLE_AUCTION_REPORTS } from '../../graphql/reports';
import ReportsPopup from './ReportsPopup';
import Spinner from '../Spinner';
import Error from '../errors/Error';
import useExtendedQuery from '../../hooks/useExtendedQuery';

AuctionReportsMenu.propTypes = {
    onCancel: PropTypes.func.isRequired,
    auctionId: PropTypes.number.isRequired,
};

function AuctionReportsMenu(props) {
    const {
        onCancel,
        auctionId,
    } = props;
    const {
        loading,
        error,
        data,
    } = useExtendedQuery(AVAILABLE_AUCTION_REPORTS, {
        variables: { auctionId },
        variablesToUrl: false,
    });
    let result;
    if (loading) {
        result = <Spinner className="auction-reports-loading" fixed />;
    } else if (error) {
        result = <Error className="auction-reports-error" error={error} />;
    } else {
        result = (
            <ReportsPopup
                reports={data.availableAuctionReports.availableReports}
                members={data.availableAuctionReports.availableMembers}
                auctionId={auctionId}
                onCancel={onCancel}
            />
        );
    }
    return result;
}

export default AuctionReportsMenu;
